import React from 'react';

const Hero = ({ onStartTrading, onUploadHat }) => {
  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="hero-promo-banner">
          <span className="promo-icon">🎁</span>
          <div className="promo-text">
            <strong className="promo-headline">Your first borrow is on us, FREE!</strong>
          </div>
        </div>
        <div>
          <div className="hero-benefits">
            Free sign up • No subscriptions • Safe and secure trades • Find us on Socials
          </div>
          <h1 className="hero-title">Trade Purses, Make Friends</h1>
          <p className="hero-subtitle">
            Join our community of sisters who love trading purses.
            Have a hot date this weekend? Ask one of your sisters to swap purses just for the weekend or how ever long you choose! Share your style and discover new looks through our community-driven trading platform.
          </p>
          <div className="hero-buttons">
            <button 
              className="btn btn-primary"
              onClick={onStartTrading}
            >
              Start Trading
            </button>
            <button 
              className="btn btn-secondary"
              onClick={onUploadHat}
            >
              Upload Your Bag
            </button>
          </div>
        </div>
        {/* <div className="hero-image">
          <RotatingCarousel />
        </div> */}
      </div>
    </section>
  );
};

export default Hero; 